import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Typography,
  Upload,
} from "antd";
import axios from "axios";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { hasAccess, objectToFormData } from "../../../utils";
import "../styles/setting.css";

import { InboxOutlined } from "@ant-design/icons";
import Text from "antd/lib/typography/Text";
import {
  companyProfile,
  companySetting,
  getCompanyCities,
  getCompanyCountries,
  getCompanyStates,
  UpdateCompanyProfile,
  updateCompanyProfile,
} from "../../../actions/companySettings";
import Loader from "../../Loader";
import PageHeader from "./../../PageHeader";
import { countries as country } from "./country";
import FilePreview from "./FilePreview";

const { Dragger } = Upload;
// const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

const ValidationSchema = yup.object().shape({
  name: yup.string().required("Please provide category name"),
  gst_no: yup.string(),
});

message.config({
  maxCount: 3,
});

const Organisation = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [companyData, setCompanyData] = React.useState({});
  const [dataLoading, setDataLoading] = React.useState(true);
  const [editMode, setEditMode] = React.useState(false);
  const [countryData, setCountryData] = React.useState("");
  const [uploadLogoData, setUploadLogoData] = React.useState({});
  const [uploadIncorpData, setUploadIncorpData] = React.useState({});
  const [uploadOtherData, setUploadOtherData] = React.useState({});
  const [uploadTANData, setUploadTANData] = React.useState({});
  const [uploadAOAData, setUploadAOAData] = React.useState({});
  const [uploadMOAData, setUploadMOAData] = React.useState({});
  const [uploadGSTCertData, setUploadGstCertData] = React.useState({});
  const [uploadPanData, setUploadPanData] = React.useState({});
  const [fileError, setFileError] = React.useState({
    message: "",
    error: false,
  });

  const [output, setOutput] = React.useState({});
  const [uploadFilesUrls, setUploadFilesUrls] = React.useState([]);
  const companySettingResponse = useSelector(
    (state) => state.companySetting.companySetting || {},
  );
  const companyProfileResponse = useSelector(
    (state) => state.companySetting.companyProfile || {},
  );
  const updateCompanyProfileResponse = useSelector(
    (state) => state.companySetting.updateCompanyProfile || {},
  );
  const loaderCheck = useSelector((state) => state.companySetting);
  const [postalcode, setPostalCode] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState({
    open: false,
    url: "",
  });

  const {
    data: {
      response: {
        company_setting: { company_id = "", company = {} } = {},
      } = {},
    } = {},
  } = companySettingResponse;
  // const { data: { response: { countries = [] } = {} } = {} } = companyCountriesResponse;
  // const { data: { response: { states = [] } = {} } = {} } = companyStatesResponse;
  // const { data: { response: { cities = [] } = {} } = {} } = companyCitiesResponse;

  // const { Search } = Input;
  const searchRef = useRef();
  const handleSearch = (value) => {
    setPostalCode(value);
    if (searchRef.current) {
      clearTimeout(searchRef.current);
    }
    searchRef.current = setTimeout(() => {
      axios
        .get(
          "https://api.worldpostallocations.com/pincode?postalcode=" +
            value +
            "&countrycode=" +
            countryData +
            "",
        )
        .then((response) => {
          setOutput(
            response?.data?.result?.[0] ? response?.data?.result?.[0] : {},
          );
        });
    }, 500);
  };
  const handleSearchCountry = (value, country) => {
    axios
      .get(
        "https://api.worldpostallocations.com/pincode?postalcode=" +
          value +
          "&countrycode=" +
          country +
          "",
      )
      .then((response) => {
        setOutput(
          response?.data?.result?.[0] ? response?.data?.result?.[0] : {},
        );
      });
  };
  React.useEffect(() => {
    Object.values(loaderCheck).forEach((val) => setDataLoading(val.loading));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaderCheck]);

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const onFileChange = (info, name) => {
    const nextState = {};

    switch (info.file.status) {
      case "uploading":
        // Allow PNG, JPG, JPEG, and PDF
        const isValidType = [
          "image/png",
          "image/jpg",
          "image/jpeg",
          "application/pdf",
        ].includes(info.file.type);

        if (!isValidType) {
          setFileError({
            message: `Only PNG, JPG, JPEG, and PDF files are allowed`,
            error: name,
          });
          nextState.selectedFile = null;
          nextState.selectedFileList = [];
        } else {
          setFileError({
            message: "",
            error: false,
          });
          nextState.selectedFileList = [info.file];
          nextState.selectedFile = info.file;
        }
        break;

      case "done":
        nextState.selectedFile = info.file;
        nextState.selectedFileList = [info.file];
        break;

      default:
        // Handle error or removal
        nextState.selectedFile = null;
        nextState.selectedFileList = [];
    }

    // Update state based on the file category (name)
    switch (name) {
      case "logo":
        setUploadLogoData(nextState);
        break;
      case "incorporation":
        setUploadIncorpData(nextState);
        break;
      case "other":
        setUploadOtherData(nextState);
        break;
      case "tan":
        setUploadTANData(nextState);
        break;
      case "aoa":
        setUploadAOAData(nextState);
        break;
      case "moa":
        setUploadMOAData(nextState);
        break;
      case "gst_certificate":
        setUploadGstCertData(nextState);
        break;
      case "pan":
        setUploadPanData(nextState);
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    dispatch(companySetting({}));
    dispatch(getCompanyCountries());
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (company_id) {
      dispatch(companyProfile({ id: company_id }));
      dispatch(getCompanyStates({ country: company.country }));
      dispatch(getCompanyCities({ state: company.state }));
    }
    // eslint-disable-next-line
  }, [company]);

  React.useEffect(() => {
    const { data: { status = "", errors = "" } = {} } =
      updateCompanyProfileResponse;
    if (status) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      message.success(
        <span className="messageText">{"Profile updated successfully."}</span>,
      );
      dispatch({
        type: UpdateCompanyProfile.RESET,
      });
      dispatch(companyProfile({ id: company_id }));
      dispatch(companySetting({}));
      setUploadLogoData({});
      setUploadIncorpData({});
      setUploadOtherData({});
      setUploadAOAData({});
      setUploadMOAData({});
      setUploadGstCertData({});
      setUploadPanData({});
      setEditMode(false);
    } else if (status === false) {
      dispatch({
        type: UpdateCompanyProfile.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanyProfileResponse]);

  React.useEffect(() => {
    const { data: { response: { company = {} } = {}, status = false } = {} } =
      companyProfileResponse;
    if (status && company) {
      setCompanyData(company);
      form.setFieldsValue({
        city: company.city,
        state: company.state,
        country: company.country,
        gst_no: company.gst_no,
        incorporation: company.incorporation,
        logo: company.logo,
        name: company.name,
        address: company.address,
        office_no: company.office_no,
        other: company.other,
        other_doc_description: company.other_doc_description,
        gst_certificate: company.gst_certificate,
        pincode: company.pincode,
        primary_contact_name: company.primary_contact_name,
        primary_email: company.primary_email,
        primary_phone: company.primary_phone,
        registration_no: company.registration_no,
        series: company.series,
        tan_no: company.tan_no,
        account_ifsc: company.account_ifsc,
        account_name: company.account_name,
        account_number: company.account_number,
        address_proof: company.address_proof,
        bank_address: company.bank_address,
        bank_branch: company.bank_branch,
        bank_name: company.bank_name,
      });
      setOutput((obj) => ({
        ...obj,
        state: company.state,
        district: company.city,
      }));
      setCountryData(
        country?.find((ele) => ele.value === company.country)?.code,
      );
      setPostalCode(company?.pincode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyProfileResponse]);

  const handleSubmit = (values) => {
    const payload = {};
    [
      "city",
      "gst_no",
      "incorporation",
      "name",
      "office_no",
      "other",
      "gst_certificate",
      "other_doc_description",
      "pincode",
      "primary_contact_name",
      "primary_email",
      "primary_phone",
      "registration_no",
      "series",
      "tan_no",
      "country",
      "state",
      "city",
      "address",
    ].forEach((item) => {
      if (item === "state") {
        payload[item] = output?.state;
      } else if (item === "city") {
        payload[item] = output?.district;
      } else if (values[item]) {
        payload[item] = values[item];
      }
    });

    if (uploadLogoData.selectedFile) {
      payload["logo"] = uploadLogoData?.selectedFile?.originFileObj;
    }
    if (uploadIncorpData.selectedFile) {
      payload["incorporation"] = uploadIncorpData?.selectedFile?.originFileObj;
    }
    if (uploadOtherData.selectedFile) {
      payload["other"] = uploadOtherData?.selectedFile?.originFileObj;
    }
    if (uploadTANData.selectedFile) {
      payload["tan"] = uploadTANData?.selectedFile?.originFileObj;
    }
    if (uploadAOAData?.selectedFile) {
      payload["aoa"] = uploadAOAData?.selectedFile?.originFileObj;
    }
    if (uploadMOAData?.selectedFile) {
      payload["moa"] = uploadMOAData?.selectedFile?.originFileObj;
    }
    if (uploadGSTCertData?.selectedFile) {
      payload["gst_certificate"] =
        uploadGSTCertData?.selectedFile?.originFileObj;
    }
    if (uploadPanData?.selectedFile) {
      payload["pan"] = uploadPanData?.selectedFile?.originFileObj;
    }

    console.log("ori payload", { payload, uploadLogoData, uploadIncorpData });
    ValidationSchema.validate(payload)
      .then(function ({ ...value }) {
        Object.keys(payload).forEach((key) => {
          if (!payload[key]) {
            delete payload[key];
          }
        });
        dispatch(
          updateCompanyProfile(
            objectToFormData({
              ...payload,
              id: companyData.id,
            }),
          ),
        );
      })
      .catch(function (err) {});
  };

  const handleCountryData = (value) => {
    setCountryData(value);
    if (postalcode) handleSearchCountry(postalcode, value);
    // dispatch(getCompanyStates({ country: value }));
  };

  const getBase64 = (img) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(img);
    });
  };

  const handleBeforeUpload = async (file, fileList, documentsType) => {
    const allowedExtensions = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes

    if (
      !allowedExtensions.includes(file.type) ||
      (documentsType == "logo" && file.type === "application/pdf")
    ) {
      // console.error("Invalid file type. Allowed types are PNG, JPG, JPEG, and PDF.");
      message.error(
        <span className="messageText">{`Invalid file type. Allowed types are ${documentsType == "logo" ? " PNG or JPG." : "PNG, JPG, or PDF."}`}</span>,
      );
      return false; // Prevent upload
    }

    if (file.size > maxFileSize) {
      console.error("File size exceeds 5 MB.");
      return false; // Prevent upload
    }
    const fileURL = await getBase64(file);
    setUploadFilesUrls((prevData) => {
      const isAlreadyUploadedIndex = prevData?.findIndex(
        (fileData) => fileData?.type === documentsType,
      );
      if (isAlreadyUploadedIndex !== -1) {
        const updatedData = [...prevData];
        updatedData[isAlreadyUploadedIndex] = {
          ...updatedData[isAlreadyUploadedIndex],
          url: fileURL,
          fileType: file.type,
        };
        return updatedData;
      }

      return [
        ...prevData,
        {
          type: documentsType,
          url: fileURL,
          fileType: file.type,
        },
      ];
    });
    return true;
  };

  const findUploadFileURL = (fileType) => {
    return uploadFilesUrls?.find((uploadFile) => uploadFile?.type == fileType);
  };

  function getFileTypeFromBase64(base64String) {
    if (!base64String || typeof base64String !== "string") {
      return null;
    }

    // Extract the MIME type from the base64 string
    const matches = base64String.match(/^data:([a-zA-Z0-9/+.-]+);base64,/);

    if (!matches || matches.length < 2) {
      throw new Error("Invalid base64 string format");
    }

    // Return the file type (e.g., png, jpg)
    return matches[1].split("/")[1];
  }

  return (
    <>
      {dataLoading ||
      companyProfileResponse?.loading ||
      companySettingResponse?.loading ? (
        <Loader />
      ) : null}

      <Modal
        open={isPreviewOpen?.open}
        onCancel={() => {
          setIsPreviewOpen({
            open: false,
            url: "",
          });
        }}
        footer={null}
        width="80%"
        centered
        className="preview_section_modal"
      >
        {isPreviewOpen?.fileType == "pdf" ||
        isPreviewOpen?.fileType == "application/pdf" ? (
          <div style={{ width: "100%", height: "90vh" }}>
            <iframe
              src={isPreviewOpen?.url}
              allow="fullscreen"
              style={{ width: "100%", height: "100%", margin: "auto" }}
              title="description"
            ></iframe>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              height: "90vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={isPreviewOpen?.url}
              alt="preview image"
              style={{ maxWidth: "100%", maxHeight: "100%", margin: "auto" }}
            />
          </div>
        )}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Organisation Profile`}
          navigation={{
            Home: "/dashboard/",
            Settings: "/setting/",
            "Organisation Profile": "",
          }}
        />
      </div>
      <div className="contentWrapper">
        <Title level={5}>Company Address</Title>
        <Divider />
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
          className="settings_form"
        >
          <Row style={{ gap: "4.5rem" }}>
            <Col span={12}>
              <Form.Item
                label="Company Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Company Name is required",
                  },
                ]}
              >
                <Input placeholder="Company Name" disabled={!editMode} />
              </Form.Item>
              <Form.Item
                label="Company Registration No"
                name="registration_no"
                rules={[
                  {
                    required: true,
                    message: "Company Registration No is required",
                  },
                ]}
              >
                <Input
                  placeholder="Company Registration No"
                  disabled={!editMode}
                />
              </Form.Item>
              <Form.Item
                label="Address"
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Address is required",
                  },
                ]}
              >
                <TextArea
                  // value={value}
                  // onChange={this.onChange}
                  disabled={!editMode}
                  placeholder="Enter Address"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
            <Col span={12} className="uploadSection">
              <Text>Upload your company logo</Text>
              {/* {company.logo && <img alt="" src={company.logo} className="orgaImage" />} */}
              <FilePreview
                fileURL={
                  findUploadFileURL("logo")?.url
                    ? findUploadFileURL("logo")?.url
                    : companyData?.logo
                }
                fileType={
                  findUploadFileURL("logo")?.fileType
                    ? findUploadFileURL("logo")?.fileType
                    : getFileTypeFromBase64(companyData?.logo)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                fileList={[]}
                customRequest={dummyRequest}
                name="logo"
                disabled={!editMode}
                maxCount={1}
                onChange={(evt) => onFileChange(evt, "logo")}
                // beforeUpload={handleBeforeUpload}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "logo")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG or PNG
                  <br />
                  Or click here to attach <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              {/* <p className="hint">
                Preferred Image Size: 240px x 240px @ 72 DPI Maximum size of 5MB.
              </p> */}
              <p className="errorMsg">
                {fileError.error === "logo" && fileError.message}
              </p>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <Form.Item
                label="Country"
                name="country"
                rules={[
                  {
                    required: true,
                    message: "Country is required",
                  },
                ]}
              >
                <Select
                  style={{ width: 200 }}
                  placeholder="Select Country"
                  options={country}
                  disabled={!editMode}
                  showSearch
                  onChange={(val, data) => {
                    handleCountryData(data.code);
                  }}
                  value={
                    country?.find((ele) => ele.code === countryData)?.value
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item
                label="Pincode"
                name="pincode"
                rules={[
                  {
                    required: true,
                    message: "Pincode is required",
                  },
                ]}
              >
                <Input
                  placeholder="pincode"
                  className="ml1 searchBox"
                  disabled={!editMode}
                  style={{ width: 200 }}
                  value={postalcode}
                  onChange={(e) => {
                    if (Number.isNaN(Number(e.target.value))) {
                      return;
                    }
                    handleSearch(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="State"
                rules={[
                  {
                    required: true,
                    message: "State is required",
                  },
                ]}
              >
              <Input
                  name="state"
                  style={{ width: 200 }}
                  placeholder="State"
                  disabled={!editMode}
                  value={output?.state}
                  onChange={(e) => {
                    setOutput({
                      ...output,
                      state: e.target.value,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="City"
                rules={[
                  {
                    required: true,
                    message: "City is required",
                  },
                ]}
              >
                <Input
                  style={{ width: 200 }}
                  placeholder="City"
                  name="city"
                  disabled={!editMode}
                  value={output?.district}
                  onChange={(e) => {
                    setOutput({
                      ...output,
                      district: e.target.value,
                    });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ gap: "1rem" }}>
            <Col span={8}>
              <Form.Item
                label="Office Number"
                name="office_no"
                rules={[
                  {
                    required: true,
                    message: "Office No is required",
                  },
                ]}
              >
                <Input placeholder="Office Number" disabled={!editMode} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="GSTIN No"
                name="gst_no"
                rules={[
                  {
                    // required: true,
                    message: "GSTIN No is required",
                  },
                ]}
              >
                <Input placeholder="GSTIN No" disabled={!editMode} />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item
                label="TAN No"
                name="tan_no"
                rules={[
                  {
                    // required: true,
                    message: "TAN No is required",
                  },
                ]}
              >
                <Input placeholder="TAN No" disabled={!editMode} />
              </Form.Item>
            </Col>
          </Row>
          <Text>Upload your company documents</Text>
          <Row className="mt1">
            <Col span={12} className="uploadSectionSmall">
              <Text>Certificate of Incorporation</Text>
              {/* {company.incorporation && !uploadIncorpData.selectedFileList && <img alt="" src={company.incorporation} className="orgaImage" />} */}
              <FilePreview
                fileURL={
                  findUploadFileURL("incorporation")?.url
                    ? findUploadFileURL("incorporation")?.url
                    : companyData?.incorporation
                }
                fileType={
                  findUploadFileURL("incorporation")?.fileType
                    ? findUploadFileURL("incorporation")?.fileType
                    : getFileTypeFromBase64(companyData?.incorporation)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                fileList={[]}
                customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "incorporation")}
                name="incorporation"
                maxCount={1}
                disabled={!editMode}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "incorporation")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG, PNG or PDF
                  <br />
                  Or click here to attach <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              <p className="errorMsg">
                {fileError.error === "incorporation" && fileError.message}
              </p>
            </Col>
            <Col span={12} className="uploadSectionSmall">
              <Text>GST Certificate</Text>
              <FilePreview
                fileURL={
                  findUploadFileURL("gst_certificate")?.url
                    ? findUploadFileURL("gst_certificate")?.url
                    : companyData?.gst_certificate
                }
                fileType={
                  findUploadFileURL("gst_certificate")?.fileType
                    ? findUploadFileURL("gst_certificate")?.fileType
                    : getFileTypeFromBase64(companyData?.gst_certificate)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                name="gst_certificate"
                fileList={[]}
                customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "gst_certificate")}
                maxCount={1}
                disabled={!editMode}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "gst_certificate")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG, PNG or PDF
                  <br />
                  Or click here to attach <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              <p className="errorMsg">
                {fileError.error === "gst_certificate" && fileError.message}
              </p>
            </Col>
            <Col span={12} className="uploadSectionSmall">
              <Text>TAN</Text>
              <FilePreview
                fileURL={
                  findUploadFileURL("tan")?.url
                    ? findUploadFileURL("tan")?.url
                    : companyData?.tan
                }
                fileType={
                  findUploadFileURL("tan")?.fileType
                    ? findUploadFileURL("tan")?.fileType
                    : getFileTypeFromBase64(companyData?.tan)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                name="tan"
                fileList={[]}
                customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "tan")}
                maxCount={1}
                disabled={!editMode}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "tan")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG, PNG or PDF
                  <br />
                  Or click here to attach
                  <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              <p className="errorMsg">
                {fileError.error === "tan" && fileError.message}
              </p>
            </Col>
            <Col span={12} className="uploadSectionSmall">
              <Text>Pan</Text>
              <FilePreview
                fileURL={
                  findUploadFileURL("pan")?.url
                    ? findUploadFileURL("pan")?.url
                    : companyData?.pan
                }
                fileType={
                  findUploadFileURL("pan")?.fileType
                    ? findUploadFileURL("pan")?.fileType
                    : getFileTypeFromBase64(companyData?.pan)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                name="pan"
                fileList={[]}
                customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "pan")}
                maxCount={1}
                disabled={!editMode}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "pan")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG, PNG or PDF
                  <br />
                  Or click here to attach <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              <p className="errorMsg">
                {fileError.error === "pan" && fileError.message}
              </p>
            </Col>
            <Col span={12} className="uploadSectionSmall">
              <Text>MOA</Text>
              <FilePreview
                fileURL={
                  findUploadFileURL("moa")?.url
                    ? findUploadFileURL("moa")?.url
                    : companyData?.moa
                }
                fileType={
                  findUploadFileURL("moa")?.fileType
                    ? findUploadFileURL("moa")?.fileType
                    : getFileTypeFromBase64(companyData?.moa)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                name="moa"
                fileList={[]}
                customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "moa")}
                maxCount={1}
                disabled={!editMode}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "moa")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG, PNG or PDF
                  <br />
                  Or click here to attach <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              <p className="errorMsg">
                {fileError.error === "moa" && fileError.message}
              </p>
            </Col>
            <Col span={12} className="uploadSectionSmall">
              <Text>AOA</Text>
              <FilePreview
                fileURL={
                  findUploadFileURL("aoa")?.url
                    ? findUploadFileURL("aoa")?.url
                    : companyData?.aoa
                }
                fileType={
                  findUploadFileURL("aoa")?.fileType
                    ? findUploadFileURL("aoa")?.fileType
                    : getFileTypeFromBase64(companyData?.aoa)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                name="aoa"
                fileList={[]}
                customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "aoa")}
                maxCount={1}
                disabled={!editMode}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "aoa")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG, PNG or PDF
                  <br />
                  Or click here to attach
                  <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              <p className="errorMsg">
                {fileError.error === "aoa" && fileError.message}
              </p>
            </Col>
            <Col span={12} className="uploadSectionSmall">
              <Text>Other</Text>
              <FilePreview
                fileURL={
                  findUploadFileURL("other")?.url
                    ? findUploadFileURL("other")?.url
                    : companyData?.other
                }
                fileType={
                  findUploadFileURL("other")?.fileType
                    ? findUploadFileURL("other")?.fileType
                    : getFileTypeFromBase64(companyData?.other)
                }
                onPreview={setIsPreviewOpen}
              />
              <Dragger
                name="other"
                fileList={[]}
                customRequest={dummyRequest}
                onChange={(evt) => onFileChange(evt, "other")}
                maxCount={1}
                disabled={!editMode}
                beforeUpload={(file, fileList) =>
                  handleBeforeUpload(file, fileList, "other")
                }
              >
                <p className="ant-upload-text">
                  <InboxOutlined />
                  Drag here to upload JPG, PNG or PDF
                  <br />
                  Or click here to attach
                  <br />
                  Maximum size of 5MB.
                </p>
              </Dragger>
              <p className="errorMsg">
                {fileError.error === "other" && fileError.message}
              </p>
              <Form.Item name="other_doc_description">
                <Input
                  placeholder="Describe the document"
                  disabled={!editMode || companyData.other_doc_description}
                  style={{ width: "360px", marginTop: "8px" }}
                  maxLength={256}
                />
              </Form.Item>
            </Col>
          </Row>
          <Title level={5} className="mt2">
            Corporate Admin
          </Title>
          <Divider />
          <Row style={{ gap: "1rem" }}>
            <Col span={10}>
              <Form.Item label="Contact Name" name="primary_contact_name">
                <Input
                  placeholder="Contact Name"
                  disabled={!editMode || company.primary_contact_name}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Contact Email" name="primary_email">
                <Input
                  placeholder="Contact Email"
                  disabled={!editMode || company.primary_email}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Contact Number" name="primary_phone">
                <Input
                  placeholder="Contact Number"
                  disabled={!editMode || company.primary_phone}
                />
              </Form.Item>
            </Col>
          </Row>
          {/*<Title level={5} className="mt2">
            Regional Settings
          </Title>
          <Divider />
          <Row>
            <Col span={12}>
              <Form.Item label="Base Currency" name="base_currency">
                <Input placeholder="Base Currency" />
              </Form.Item>
              <Form.Item label="Time Zone" name="time_zone">
                <Input placeholder="Time Zone" />
              </Form.Item>
              <Form.Item label="Fiscal Year" name="fiscal_year">
                <Input placeholder="Fiscal Year" />
              </Form.Item>
            </Col>
        </Row>*/}
          {/* <Title level={5} className="mt2">
            Bank Details
          </Title>
          <Divider />
          <Row>
            <Col span={8}>
              <Form.Item label="Account name" name="account_name">
                <Input placeholder="Account name" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Account IFSC" name="account_ifsc">
                <Input placeholder="Account IFSC" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Account Number" name="account_number">
                <Input placeholder="Account Number" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item label="Bank name" name="bank_name">
                <Input placeholder="Bank name" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Bank branch" name="bank_branch">
                <Input placeholder="Bank branch" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Bank address" name="bank_address">
                <Input placeholder="Bank address" />
              </Form.Item>
            </Col>
          </Row> */}
          {!editMode && hasAccess("organisation_settings", "write") && (
            <Button
              className="formButton mt1 primaryButton"
              onClick={() => setEditMode(true)}
            >
              Edit
            </Button>
          )}
          {editMode && (
            <>
              <Button
                key="1"
                htmlType="submit"
                className="formButton mt1 primaryButton"
                disabled={updateCompanyProfileResponse?.loading}
              >
                Save
              </Button>
              <Button
                key="2"
                className="cancelButton ml1 mt1"
                onClick={() => {
                  setEditMode(false);
                  if (company)
                    form.setFieldsValue({
                      city: company.city,
                      state: company.state,
                      country: company.country,
                      gst_no: company.gst_no,
                      incorporation: company.incorporation,
                      logo: company.logo,
                      name: company.name,
                      address: company.address,
                      office_no: company.office_no,
                      other: company.other,
                      other_doc_description: company.other_doc_description,
                      gst_certificate: company.gst_certificate,
                      pincode: company.pincode,
                      primary_contact_name: company.primary_contact_name,
                      primary_email: company.primary_email,
                      primary_phone: company.primary_phone,
                      registration_no: company.registration_no,
                      series: company.series,
                      tan_no: company.tan_no,
                      account_ifsc: company.account_ifsc,
                      account_name: company.account_name,
                      account_number: company.account_number,
                      address_proof: company.address_proof,
                      bank_address: company.bank_address,
                      bank_branch: company.bank_branch,
                      bank_name: company.bank_name,
                    });
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </Form>
      </div>
    </>
  );
};

export default Organisation;
